import types from './types';

const setCurrentResource = resource => ({
  type: types.SET_RESOURCE,
  payload: {
    resource
  }
});
const setDispatch = currentDispatchID => ({
  type: types.SET_DISPATCH,
  payload: {
    currentDispatchID
  }
});

const setResourceFields = fields => ({
  type: types.SET_RESOURCE_FIELDS,
  payload: {
    fields
  }
});

const setRequestFields = request => ({
  type: types.SET_REQUEST_FIELDS,
  payload: {
     request
  }
});

const clearCurrentResource = () => ({
  type: types.CLEAR_RESOURCE
});

const setInitialResourceFilter = filterState => ({
  type: types.SET_INITIAL_RESOURCE_FILTER,
  payload: {
    filterState
  }
});

const updateResourceFilterValues = filter => ({
  type: types.UPDATE_RESOURCE_FILTER_VALUES,
  payload: {
    ...filter
  }
});

const updateResourceSqlFilter = sql => ({
  type: types.UPDATE_RESOURCE_SQL_FILTER,
  payload: {
    sql
  }
});

const clearResourceFilters = filter => ({
  type: types.CLEAR_RESOURCE_FILTERS,
  payload: {
    ...filter
  }
});

const setInitialResourceListColumns = columns => ({
  type: types.SET_INITIAL_RESOURCE_LIST_COLUMNS,
  payload: {
    columns
  }
});

const addResourceListColumn = (columnName, indexPosition) => ({
  type: types.ADD_RESOURCE_LIST_COLUMN,
  payload: {
    columnName,
    indexPosition
  }
});

const removeResourceListColumn = columnName => ({
  type: types.REMOVE_RESOURCE_LIST_COLUMN,
  payload: {
    columnName
  }
});

export default {
  setCurrentResource,
  setDispatch,
  setResourceFields,
  setRequestFields,
  clearCurrentResource,
  setInitialResourceFilter,
  updateResourceFilterValues,
  updateResourceSqlFilter,
  clearResourceFilters,
  setInitialResourceListColumns,
  addResourceListColumn,
  removeResourceListColumn
};



// WEBPACK FOOTER //
// ./src/redux/resource/actions.js